import {
  CheckCircleOutlined,
  FileOutlined,
  PieChartOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { Menu, MenuProps } from "antd";
import { useContext, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext/Index";
import { InterviewRoundTab } from "../../Interface/Index";
import { DashboardContext } from "../../Context/DashboardContext";

type MenuItem = Required<MenuProps>["items"][number];

const sidebarStyle: React.CSSProperties = {
  borderRadius: 8,
  overflowY: "auto",
  background: "#ffffff",
  border: "1px solid #f0f0f0",
};

const SideNav = ({ onClick }: any) => {
  const { isUserLoggedIn } = useAuth();
  const { jobDescriptionId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const {
    enabledInterviewRoundTabs,
    showOnlineInterviewTab,
    selectedKey,
    setSelectedKey,
    showResultTab,
  } = useContext(DashboardContext);

  const getCurrentKey = () => {
    const pathSegments = location.pathname.split("/").filter(Boolean);

    if (pathSegments.includes("interview-round")) {
      const sessionId =
        pathSegments[pathSegments.indexOf("interview-round") + 1];
      return sessionId ? `session-${sessionId}` : `requirements`;
    }

    if (pathSegments.includes("requirements")) {
      return "requirements";
    }

    if (pathSegments.includes("online-interview")) {
      return "online-interview";
    }

    if (pathSegments.includes("result")) {
      return "result";
    }

    return "requirements";
  };

  useEffect(() => {
    const currentKey = getCurrentKey();
    if (currentKey !== selectedKey) {
      setSelectedKey(currentKey);
    }
  }, [location.pathname, jobDescriptionId]);

  const handleRoundClick = (sessionId: string | null) => {
    if (!sessionId) return;
    navigate(`/${jobDescriptionId}/interview-round/${sessionId}`);
  };

  const items: MenuItem[] = [
    {
      key: "requirements",
      icon: <PieChartOutlined />,
      label: "Requirements",
      onClick: () => navigate(`/${jobDescriptionId}/requirements`),
    },
    ...(enabledInterviewRoundTabs?.length
      ? [...enabledInterviewRoundTabs]
          .sort((a, b) => a.roundNumber - b.roundNumber)
          .flatMap((round: InterviewRoundTab) => [
            {
              key: round.sessionId
                ? `session-${round.sessionId}`
                : round.roundId,
              icon: <FileOutlined />,
              label: (
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 8,
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    lineHeight: "1.4",
                  }}
                >
                  <span
                    style={{
                      maxWidth: "100%",
                      display: "block",
                      overflowWrap: "break-word",
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    {round.roundName}
                  </span>
                </div>
              ),

              disabled: !isUserLoggedIn || !round.isEnabled,
              onClick: () => handleRoundClick(round.sessionId),
            },
          ])
      : []),
    ...(showOnlineInterviewTab
      ? [
          {
            key: "online-interview",
            icon: <TeamOutlined />,
            label: "Online Interview",
            disabled: !showOnlineInterviewTab,
            onClick: () => navigate(`/${jobDescriptionId}/online-interview`),
          },
        ]
      : []),
    ...(showResultTab
      ? [
          {
            key: "result",
            icon: <CheckCircleOutlined />,
            label: "Result",
            onClick: () => navigate(`/${jobDescriptionId}/result`),
          },
        ]
      : []),
  ];

  return (
    <div style={sidebarStyle} className="dashboard_side_nav">
      <Menu mode="inline" items={items} selectedKeys={[selectedKey]} />
    </div>
  );
};

export default SideNav;
